import { gql } from '@apollo/client';
import { FragProductReviewItem } from './frag-product-review-item';

export const PRODUCT_REVIEW = gql`
  ${FragProductReviewItem}

  query ProductReview($id: BigInt!) {
    product_reviewsCollection(filter: { id: { eq: $id } }, first: 1) {
      edges {
        node {
          ...FragProductReviewItem
        }
      }
    }
  }
`;

export const PRODUCT_REVIEWS = gql`
  ${FragProductReviewItem}

  query ProductReviews($first: Int, $after: Cursor, $filter: product_reviewsFilter) {
    product_reviewsCollection(first: $first, after: $after, filter: $filter, orderBy: [{ created_at: DescNullsLast }]) {
      edges {
        node {
          ...FragProductReviewItem
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;

export const CREATE_PRODUCT_REVIEW = gql`
  ${FragProductReviewItem}

  mutation CreateProductReview($input: product_reviewsInsertInput!) {
    insertIntoproduct_reviewsCollection(objects: [$input]) {
      records {
        ...FragProductReviewItem
      }
    }
  }
`;

export const UPDATE_PRODUCT_REVIEW = gql`
  ${FragProductReviewItem}

  mutation UpdateProductReview($filter: product_reviewsFilter!, $set: product_reviewsUpdateInput!) {
    updateproduct_reviewsCollection(filter: $filter, set: $set) {
      records {
        ...FragProductReviewItem
      }
    }
  }
`;

export const DELETE_PRODUCT_REVIEW = gql`
  mutation DeleteProductReview($filter: product_reviewsFilter!) {
    deleteFromproduct_reviewsCollection(filter: $filter) {
      records {
        id
      }
    }
  }
`;
